import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { DealComponent } from '../Deal'
import { FilterSliderComponent } from '../FilterSlider'
import { LayoutPage } from '../LayoutPage'
import { SpinnerComponent } from '../Spinner'

import { useAppContext } from '../../hooks/useAppContext'
import { useControlSearch } from '../../hooks/useControlSearch'
import { useInfiniteScroll } from '../../hooks/useInfiniteScroll'
import { useSimpleState } from '../../hooks/useSimpleState'
import { useView } from '../../hooks/useView'

import dayjs from 'dayjs'

import './index.css'

const DealsComponent = ({ value, config={}, events={} }) => {
    const navigate = useNavigate();
    const {ac} = useAppContext()

    const {_state} = useSimpleState({
        fetching: false,
        filterPriceRange: [10, 30]
    })

    const {_view} = useView({
        initialView: 'loading',
        views: {
            loading: renderLoading,
            main: renderMain
        }
    })

    const {_control, _results, _params, _pagination} = useControlSearch({
        afterFetch: () => {
            _view.set('main')
            restoreScrollPosition()
        }
    })

    const {sentinelRef} = useInfiniteScroll({
        enabled: _view.active() === 'main' && _control.hasMore(),
        onIntersect: _control.loadMore
    })

    const restoreScrollPosition = () => {
        let savedY = ac._state.get('homeScrollY')

        if (typeof savedY !== 'number')
            return

        ac._state.set('homeScrollY', null)

        setTimeout(() => {
            window.scrollTo(0, savedY)
        }, 0)
    }

    useEffect(() => {
        let throttled = false

        const handleScroll = () => {
            if (throttled)
                return

            throttled = true

            setTimeout(() => {
                ac._state.set('homeScrollY', window.scrollY)
                throttled = false
            }, 200)
        }

        window.addEventListener('scroll', handleScroll)

        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const handleFilterPriceChange = (value) => {
        _params.set('priceFinal', value)
    }

    const handleFilterPriceReset = () => {
        _params.set('priceFinal', null)
    }

    const handleDealClick = (item) => {
        _control.fetchClick(item)

        setTimeout(() => {
            window.open(item.url, '_blank')
        }, 500)
    }

    const handleDealClickDead = (item) => {
        _control.fetchClickDead(item)
    }

    const getList = () => {
        const deals = _results.get()?.body?.data

        if (!deals?.length) {
            return (
                <div className="deals-dealsSectionNoResults">
                    <h2>No Deals...</h2>
                    <p>Start saving for when more show up!</p>
                </div>
            )
        }

        return (
            deals.map((item, index) => {
                return (
                    <div className="deals-dealsSection" key={`deals-dealsSection-${item.date}-${index}`}>
                        <div className="deals-dealsSectionDate">
                            <span className="bubble bubble-green">{dayjs(item.date).format('MMMM D, YYYY')}</span>
                        </div>

                        <div className="deals-dealsSectionItems">
                            {item.items.map((itm) => {
                                return <DealComponent value={itm} key={`deal-${itm.id}`} events={{
                                    handleClick: handleDealClick,
                                    handleClickDead: handleDealClickDead
                                }} />
                            })}
                        </div>
                    </div>
                )
            })
        )
    }

    function renderLoading() {
        return (
            <div className="deals-deals">
                <SpinnerComponent />
            </div>
        )
    }

    function renderMain() {
        return (
            <div className="deals-deals">
                {/* <div className="deals-filters">
                    <FilterSliderComponent value={_state.get('filterPriceRange')} events={{
                        handleChange: handleFilterPriceChange,
                        handleClickReset: handleFilterPriceReset
                    }} />
                </div> */}
                <div className="deals-dealsCollection">
                    {getList()}
                </div>

                {_control.hasMore() ? (
                    <div className="deals-dealsLoadMore" ref={sentinelRef}>
                        {_pagination.get('loadingMore') ? <SpinnerComponent config={{ size: 'small' }} /> : null}
                    </div>
                ) : null}
            </div>
        )
    }

    return (
        <div className="c-Deals">
            {_view.get()}
        </div>
    )
}

export { DealsComponent }
